"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthoredComparisonText = void 0;
var comparison_1 = require("../features/comparison");
var metricValue_1 = require("../features/metricValue");
var threshold_1 = require("../features/threshold");
var localization_1 = require("../localization");
var models_1 = require("../models");
var numberFormatter_1 = require("./numberFormatter");
var getAuthoredComparisonText = function (definition) {
    var _a, _b;
    if ((0, threshold_1.isDefaultLineStaticRefLine)(definition)) {
        var target = (0, threshold_1.getStaticTargetValue)(definition);
        var formatString = (0, metricValue_1.getMeasureFormatString)(definition);
        return target !== undefined ? (0, numberFormatter_1.formatValueAsMetricNumber)(target, formatString) : '';
    }
    else {
        var units = (_a = (0, comparison_1.getNumberOfUnitsOrAmount)(definition)) !== null && _a !== void 0 ? _a : 1;
        var granularity = (_b = (0, comparison_1.getComparisonGranularity)(definition)) !== null && _b !== void 0 ? _b : models_1.DateGranularity.UNKNOWN;
        return getHistoricalComparisonText(granularity, units);
    }
};
exports.getAuthoredComparisonText = getAuthoredComparisonText;
var getHistoricalComparisonText = function (date, units) {
    switch (date) {
        case models_1.DateGranularity.SECOND: {
            return units === 1
                ? localization_1.Messages.metricsSecondComparisonSingular()
                : localization_1.Messages.metricsSecondComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.MINUTE: {
            return units === 1
                ? localization_1.Messages.metricsMinuteComparisonSingular()
                : localization_1.Messages.metricsMinuteComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.HOUR: {
            return units === 1
                ? localization_1.Messages.metricsHourComparisonSingular()
                : localization_1.Messages.metricsHourComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.DAY: {
            return units === 1
                ? localization_1.Messages.metricsDayComparisonSingular()
                : localization_1.Messages.metricsDayComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.WEEK: {
            return units === 1
                ? localization_1.Messages.metricsWeekComparisonSingular()
                : localization_1.Messages.metricsWeekComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.MONTH: {
            return units === 1
                ? localization_1.Messages.metricsMonthComparisonSingular()
                : localization_1.Messages.metricsMonthComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.QUARTER: {
            return units === 1
                ? localization_1.Messages.metricsQuarterComparisonSingular()
                : localization_1.Messages.metricsQuarterComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.YEAR: {
            return units === 1
                ? localization_1.Messages.metricsYearComparisonSingular()
                : localization_1.Messages.metricsYearComparisonPlural({ value: units.toString() });
        }
        case models_1.DateGranularity.UNKNOWN: {
            return units === 1
                ? localization_1.Messages.metricsMarkComparisonSingular()
                : localization_1.Messages.metricsMarkComparisonPlural({ value: units.toString() });
        }
        case undefined:
        default: {
            return '';
        }
    }
};
//# sourceMappingURL=comparisonText.js.map